import React from 'react';

interface Props {
	label: string;
	onClick: () => void;
}

const DropdownButtonItem = (props: Props) => {
	const { label, onClick } = props;
	return (
		<div
			style={{ paddingLeft: '16px', paddingRight: '16px', width: '100%' }}
			id='dropdownButtonItem'
			onClick={onClick}
		>
			<div>{label}</div>
		</div>
	);
};

export default DropdownButtonItem;
